import { CheckboxIcon, CheckboxSolidIcon, CheckNormalIcon, MinusIcon, StackIcons } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiCheckbox = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: (
          <StackIcons variant="centered">
            <CheckboxSolidIcon />
            <CheckNormalIcon />
          </StackIcons>
        ),
        icon: <CheckboxIcon />,
        indeterminateIcon: (
          <StackIcons variant="centered">
            <CheckboxSolidIcon />
            <MinusIcon />
          </StackIcons>
        ),
        disableRipple: true,
        color: 'dark',
      },

      styleOverrides: {
        root: {
          padding: 0,
          marginLeft: 0,
          borderRadius: misc.borderRadius(2),
          '&.Mui-disabled': {
            'svg:first-of-type': {
              color: palette.action.disabledBackground,
            },
            'svg:last-of-type': {
              color: palette.action.disabled,
            },
          },

          '.DhlSvgStack-root svg:last-of-type': {
            color: palette.static.light,
          },
          // when marked as required, an additional span is added for the asterix. in addition, both of the spans are wrapped in a div
          '&.MuiCheckbox-root + .MuiFormControlLabel-label, + div > .MuiFormControlLabel-label': {
            marginLeft: spacing(1.5),
          },
          ...misc.createFocusVisibleState({
            outline: misc.borderStyle('dark.states.focus', 3),
            boxShadow: 'none',
          }),
          '&:hover': {
            outline: misc.borderStyle('dark.states.hover', 3),
          },
        },
      },
      variants: [
        {
          props: { color: 'dark' },
          style: ({ theme }) => [
            theme.applyStyles('dark', {
              color: palette.static.light,

              '&.Mui-checked:not(.MuiCheckbox-indeterminate):not(.Mui-disabled)': {
                color: palette.static.light,
                'svg:last-of-type': {
                  color: palette.static.dark,
                },
              },

              '&.MuiCheckbox-indeterminate:not(.Mui-disabled)': {
                color: palette.static.light,
                'svg:last-of-type': {
                  color: palette.static.dark,
                },
              },
            }),
          ],
        },
      ],
    },
  }) satisfies ComponentCreation
